$buttonHeightMobile: 32px;
$buttonHeightTablet: 54px;
$activeOffsetMobile: 85%;
$activeOffsetTablet: 50%;
$activeOffsetDesktop: 33.33%;

.ux-iws-marginal-column {
    --transition-duration: 0.5s;
    position: relative;
}

.ux-iws-marginal-column__button {
    right: $buttonHeightMobile * 0.5;
    top: 50%;
    height: $buttonHeightMobile;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(50%, -50%) rotate(-90deg);
    padding: 0 15px;
    color: $color-white;
    background: $color-green;
    z-index: 908;
    position: fixed;
    transform-origin: 50% 50%;
    white-space: nowrap;
    cursor: pointer;
    transition: right var(--transition-duration) ease;

    @media only screen and (min-width: $tablet) {
        right: $buttonHeightTablet * 0.5;
        height: $buttonHeightTablet;
        padding: 0 25px;
    }

    .ux-iws-marginal-column__label {
        transform: translate(0, 1px);
    }

    ux-icon {
        margin-left: 15px;
        display: none;
        transform: rotate(-180deg);
        transition: transform var(--transition-duration) ease;

        @media only screen and (min-width: $tablet) {
            display: block;
        }
    }

    &.is-active {
        right: calc($activeOffsetMobile + $buttonHeightMobile * 0.5);

        @media only screen and (min-width: $tablet) {
            right: calc($activeOffsetTablet + $buttonHeightTablet * 0.5);
        }

        @media only screen and (min-width: $desktop-s) {
            right: calc($activeOffsetDesktop + $buttonHeightTablet * 0.5);
        }

        ux-icon {
            transform: rotate(0deg);
        }
    }

    &.is-hidden {
        display: none;
    }
}

.ux-iws-marginal-column__content {
    top: 0;
    right: -$activeOffsetMobile;
    width: $activeOffsetMobile;
    height: 100%;
    background: $color-white;
    background-image: linear-gradient(0deg, #efefef 0, #fff 50%);
    box-shadow: -6px 0 10px 0 rgba(0, 0, 0, 0);
    position: fixed;
    padding: 47px 30px 120px;
    overflow-y: auto;
    z-index: 999;
    transition:
        right var(--transition-duration) ease,
        box-shadow var(--transition-duration) ease;

    &::before {
        content: "";
        left: 0;
        top: 0;
        width: 1px;
        height: 100%;
        background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.15) 50%,
            rgba(0, 0, 0, 0) 100%
        );
        position: absolute;
    }

    @media only screen and (min-width: $tablet) {
        right: -$activeOffsetTablet;
        width: $activeOffsetTablet;
        padding: 47px 30px 120px 45px;
    }

    @media only screen and (min-width: $desktop-s) {
        right: -$activeOffsetDesktop;
        width: $activeOffsetDesktop;
    }

    &.is-active {
        right: 0;
        box-shadow: -6px 0 10px 0 rgba(0, 0, 0, 0.1);
    }

    &.is-active-always {
        width: 100%;
        height: auto;
        right: 0;
        overflow-y: visible;
        box-shadow: none;
        background-image: none;
        position: relative;
    }

    .ux-iws-marginal-column__headline {
        padding-bottom: 20px;
        border-bottom: 1px solid $color-gray-borders;
    }
}
